import React from 'react';

// Icon mưa
export const RainIcon = ({ size = 24, color = "#3b82f6" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L13.09 8.26L19 7L13.09 15.74L12 22L10.91 15.74L5 17L10.91 8.26L12 2Z" fill={color}/>
    <path d="M8 12L9.5 14.5L12 13L9.5 11.5L8 12Z" fill={color} opacity="0.6"/>
    <path d="M16 12L17.5 14.5L20 13L17.5 11.5L16 12Z" fill={color} opacity="0.6"/>
    <path d="M6 18L7.5 20.5L10 19L7.5 17.5L6 18Z" fill={color} opacity="0.4"/>
    <path d="M18 18L19.5 20.5L22 19L19.5 17.5L18 18Z" fill={color} opacity="0.4"/>
  </svg>
);

// Icon sóng biển
export const OceanIcon = ({ size = 24, color = "#06b6d4" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12C2 12 4 8 8 8C12 8 14 12 18 12C20 12 22 10 22 10" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M2 16C2 16 4 12 8 12C12 12 14 16 18 16C20 16 22 14 22 14" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
    <path d="M2 20C2 20 4 16 8 16C12 16 14 20 18 20C20 20 22 18 22 18" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    <circle cx="4" cy="6" r="1" fill={color} opacity="0.6"/>
    <circle cx="20" cy="4" r="1" fill={color} opacity="0.6"/>
    <circle cx="16" cy="8" r="1" fill={color} opacity="0.4"/>
  </svg>
);

// Icon chim
export const BirdsIcon = ({ size = 24, color = "#10b981" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8 2 6 6 6 10C6 12 7 14 9 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2C16 2 18 6 18 10C18 12 17 14 15 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 10C6 8 7 6 9 5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 10C18 8 17 6 15 5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 18C8 20 10 22 12 22C14 22 16 20 16 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="12" r="1" fill={color}/>
    <circle cx="15" cy="12" r="1" fill={color}/>
    <path d="M10 15L14 15" stroke={color} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

// Icon piano
export const PianoIcon = ({ size = 24, color = "#8b5cf6" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="8" width="20" height="12" rx="2" fill={color} opacity="0.2"/>
    <rect x="2" y="8" width="20" height="12" rx="2" stroke={color} strokeWidth="2"/>
    <rect x="3" y="10" width="2" height="8" fill={color}/>
    <rect x="6" y="10" width="2" height="8" fill={color}/>
    <rect x="9" y="10" width="2" height="8" fill={color}/>
    <rect x="12" y="10" width="2" height="8" fill={color}/>
    <rect x="15" y="10" width="2" height="8" fill={color}/>
    <rect x="18" y="10" width="2" height="8" fill={color}/>
    <rect x="4.5" y="8" width="1" height="4" fill={color} opacity="0.8"/>
    <rect x="7.5" y="8" width="1" height="4" fill={color} opacity="0.8"/>
    <rect x="10.5" y="8" width="1" height="4" fill={color} opacity="0.8"/>
    <rect x="13.5" y="8" width="1" height="4" fill={color} opacity="0.8"/>
    <rect x="16.5" y="8" width="1" height="4" fill={color} opacity="0.8"/>
    <path d="M2 20L22 20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icon nhạc
export const MusicIcon = ({ size = 24, color = "#f59e0b" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18V5L21 3V16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="18" r="3" fill={color} opacity="0.2" stroke={color} strokeWidth="2"/>
    <circle cx="21" cy="16" r="3" fill={color} opacity="0.2" stroke={color} strokeWidth="2"/>
    <path d="M9 9L21 7" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
    <path d="M9 12L21 10" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
  </svg>
);

// Icon play
export const PlayIcon = ({ size = 24, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="5,3 19,12 5,21" fill={color}/>
  </svg>
);

// Icon pause
export const PauseIcon = ({ size = 24, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="4" width="4" height="16" fill={color}/>
    <rect x="14" y="4" width="4" height="16" fill={color}/>
  </svg>
);

// Icon previous
export const PreviousIcon = ({ size = 24, color = "#374151" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="11,19 2,12 11,5" fill={color}/>
    <line x1="22" y1="5" x2="22" y2="19" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icon next
export const NextIcon = ({ size = 24, color = "#374151" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="13,5 22,12 13,19" fill={color}/>
    <line x1="2" y1="5" x2="2" y2="19" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icon volume
export const VolumeIcon = ({ size = 24, color = "#6b7280" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill={color}/>
    <path d="M19.07 4.93C20.88 6.74 20.88 9.65 19.07 11.46M15.54 8.46C16.48 9.4 16.48 10.85 15.54 11.79" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Icon music toggle
export const MusicToggleIcon = ({ size = 24, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18V5L21 3V16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="18" r="3" fill={color} opacity="0.2" stroke={color} strokeWidth="2"/>
    <circle cx="21" cy="16" r="3" fill={color} opacity="0.2" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icon help
export const HelpIcon = ({ size = 24, color = "#6b7280" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="17" x2="12.01" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Function để render icon dựa trên type
export const renderTrackIcon = (type, size = 24) => {
  const iconProps = { size, color: "#ffffff" };
  
  switch (type) {
    case 'rain':
      return <RainIcon {...iconProps} color="#3b82f6" />;
    case 'ocean':
      return <OceanIcon {...iconProps} color="#06b6d4" />;
    case 'birds':
      return <BirdsIcon {...iconProps} color="#10b981" />;
    case 'piano':
      return <PianoIcon {...iconProps} color="#8b5cf6" />;
    case 'music':
      return <MusicIcon {...iconProps} color="#f59e0b" />;
    default:
      return <MusicIcon {...iconProps} color="#f59e0b" />;
  }
};
